import React from 'react';

import './SharedMailACheck.scss';

import config from '../../../config/config';
import {
  COLLEGE_DISTRIBUTE_MAX_REDEMPTION,
  DELIVERY_MAIL_CHECK_REDEMPTION,
} from '../../../settings/settings';
import If from '../../Shared/If/If';
import {
  isCollegeDistribute,
  isAutomaticSell,
} from '../../../utils/transactions-util';
import { currency, currencyNoPrecision } from '../../../utils/utils';

const SharedMailACheck = ({
  isSalesforceRep,
  customerWebViewEnabled,
  address,
  availableDate,
  dailyMax,
  description,
  heading,
  multipleAddressRestricted,
  mobileAddress,
}) => (
  <div className="share-mail-a-check">
    <div className="share-mail-a-check-heading">{heading}</div>
    <If test={address}>
      <div className="share-mail-a-check-address">{address}</div>
    </If>
    <If test={mobileAddress && !(!customerWebViewEnabled && isSalesforceRep)}>
      <div className="hidden-lg hidden-md share-mail-a-check-space">
        <a
          className="text-nowrap"
          href={`${config.rmlUrl}/usis/my-accounts/profile/contact-information`}
        >
          Update Address{' '}
        </a>{' '}
        (15 day hold)
      </div>
    </If>
    <If test={dailyMax}>
      <div className="share-mail-a-check-daily-max">
        {!customerWebViewEnabled && isSalesforceRep ? (
          <span></span>
        ) : (
          <span>
            {isCollegeDistribute()
              ? `The maximum amount that may be distributed from a 529 account is ${currency(
                  COLLEGE_DISTRIBUTE_MAX_REDEMPTION
                )} per day.`
              : `The maximum redemption amount that may be requested online and sent via check is ${
                  isAutomaticSell()
                    ? '$25,000'
                    : currencyNoPrecision(DELIVERY_MAIL_CHECK_REDEMPTION)
                } per day.`}
          </span>
        )}
      </div>
    </If>
    <div className="share-mail-a-check-daily-max">{description}</div>
    <If test={multipleAddressRestricted}>
      <div className="share-mail-a-check-multi-address-change">
        {multipleAddressRestricted}
      </div>
    </If>
    <If test={availableDate}>
      <div className="share-mail-a-check-daily-max share-mail-a-check-space">
        {availableDate}
      </div>
    </If>
  </div>
);

export default SharedMailACheck;
